import {
	Breakpoints,
	CTA,
	CTAProps,
	DesignTokenSizeEnum,
	styled,
	Text,
	TextAlignment,
	TextTag,
	ThemeProvider,
	TokenTextAppearance
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { oneformBFFNdpsSend } from 'src/bff';
import { Apellido, ConsentQuestion, Email, Error, Loading, Nombre, Telefono } from 'src/components';
import { formatPrefix, FormController, removeWhiteSpace, useGetInstalaciones, useOneFormContext } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { useTrackingManager } from 'src/feature-app/hooks/use-tracking-manager';
import { formatFlags, formatHeaders, formDataBuilder } from 'src/forms/format-fields';
import { MapaLeadsInPage } from 'src/forms/Leads/InPage';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import { GTI50LeadConfirmacion } from '../GTI50Leads2025';
import { FooterSection } from './components/FooterSection';
import { GallerySection } from './components/GallerySection';
import { HeroSection } from './components/HeroSection';
import { VideoSection } from './components/VideoSection';
import iconRed from './img/icon-red.svg';
import iconWhite from './img/icon-white.svg';
import { NavidadGTI2025ThankYou } from './NavidadGTI2025ThankYou';
import { globalStyles } from './styles';

export const BlackSection = styled.section`
	background-color: black;
	min-height: 100vh;
	width: 100%;
`;

export const FormStyled = styled.div`
	span,
	p,
	input,
	select,
	div {
		color: #ffffff !important;
	}
	button {
		background-color: #000000 !important;
		color: #ffffff !important;
		border: 1px solid #ffffff !important;
	}
	button:hover,
	button:focus,
	button:active {
		background-color: #c90010 !important;
		color: #ffffff !important;
		border: 1px solid #c90010 !important;
	}
	button:focus-visible {
		outline: none !important;
	}
	button[aria-label*='aceptar'],
	button[type*='submit'] {
		background-color: #c90010 !important;
		color: #ffffff !important;
		border: 1px solid #c90010 !important;

		&:hover {
			background-color: #a5000d !important;
			border: 1px solid #a5000d !important;
		}
	}
	label:hover {
		box-shadow: #c90010 0 0 0 1px !important;
	}
	label:focus-within {
		box-shadow: #c90010 0 0 0 2px !important;
	}
	label:focus-visible {
		outline: none;
	}
	/* MAPA */
	ul {
		background: #000000 !important;
		border: 1px solid #ffffff !important;
	}
	ul svg,
	ul svg:hover {
		fill: #ffffff !important;
	}
	.styled-wrapper-suggest {
		box-shadow: #ffffff 0px 0px 0px 1px !important;
	}

	/* Fix no existe previus step en el primer step en desktop. Añadimos width al div que corresponde previus step para centrar fields del primer step. */
	@media screen and (min-width: 960px) {
		.form-controller-wrapper .full-screen > div:nth-of-type(2) {
			/* min-width: 1px;
			height: 0; */
			display: none;
		}
	}
	.form-controller-wrapper .full-screen {
		padding: 0;
		min-height: auto !important;
	}
	.form-controller-wrapper > .full-screen {
		min-height: calc(100vh - 160px) !important;
		align-items: center;
	}

	.form-controller-wrapper > .full-screen > .content-wrapper > div,
	.form-controller-wrapper > .full-screen .title-wrapper {
		display: flex;
		justify-content: center;
	}
`;
const FormWrapper = styled.div`
	width: var(--size-grid020);
	max-width: 1140px;
	margin: 0 auto;
	padding: 0 1px;
	> div {
		width: 100%;
	}
	.form-map-wrapper > .full-screen > .content-wrapper > div > div {
		display: flex;
		> div {
			width: 100%;
			flex: 1;
		}
	}
	.form-map-wrapper .title-wrapper {
		display: none !important;
	}
	.styled-wrapper-suggest button {
	border: none !important;
	background: none !important;
		&:hover {
			background: none !important;
		}
	}
`;
const InputsWrapper = styled.div`
	width: 100%;
	padding-top: var(--size-dynamic0250);
	display: flex;
	flex-direction: column;
	gap: var(--size-dynamic0140);
	> div:not(.prefijo_telefono-input-wrapper) {
		position: relative;
		padding-top: 0;
		width: 100%;
		flex: 1;
		.input-error {
			position: absolute;
			margin: 0;
			top: calc(100% - 3px);
		}
	}
	> div.prefijo_telefono-input-wrapper {
		padding-top: 0;
		width: 100%;
		flex: 1;
		> div > div:not(.prefijo-wrapper) {
			width: 100%;
			flex: 1;
			> div {
				position: relative;
				.input-error {
					position: absolute;
					margin: 0;
					top: calc(100% - 3px);
				}
			}
		}

	}
	@media screen and (min-width: 960px) {
		flex-direction: row;
	}
`;
const ConsentQuestionWrapper = styled.div`
	> div > div:nth-child(2) > div > div {
		padding: 0 !important;
		gap: 30px;
	}
	> div > div:nth-child(3) > div > div {
		position: relative !important;
		padding: 0 !important;
		height: auto;
		background: transparent;
		gap: 30px;
	}
`;

const SubmitCTA = styled(CTA)<CTAProps>`
	max-width: 150px;
	margin-top: 30px;
	background: var(--c-red) !important;
	color: var(--c-white) !important;
	&:hover:not(:disabled),
	&:active:not(:disabled),
	&:focus:not(:disabled):not(:focus-visible) {
		background: rgb(165, 0, 13) !important;
	}
`;

const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: var(--size-${DesignTokenSizeEnum.dynamic0350});
`;

const FormHeadline = styled.div`
	& * {
		text-wrap: pretty !important;
		text-wrap: balance !important;
	}
	p {
		margin-top: calc( var(--size-${DesignTokenSizeEnum.dynamic0020}) * 4 );
	}
`;

export function NavidadGTI2025Form() {
	const { initializeForm, handleNextStep } = useOneFormContext();
	const trackingManager = useTrackingManager();
	const store = useStore();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const { loading: loadingInstallations, error: errorInstallations } = useGetInstalaciones('VW_DDB_FRM_LEM_REC_LEM', 'VOLKSWAGEN_SF_LEAD_INSTALLATION_VN_VO_SERVICE', 'vn');

	let index = 0;
	const steps: Steps[] = [
		{
			title: (
				<FormHeadline>
					<Text
						tag={TextTag.h2} appearance={ TokenTextAppearance.headline500 } bold
						textAlign={ TextAlignment.center }
					>
						Si estas Navidades te desean carbón,{ window.innerWidth > Breakpoints.b960 && <br /> } ¡han acertado!
					</Text>
					<Text
						tag={TextTag.p} appearance={ TokenTextAppearance.bigcopy100 }
						textAlign={ TextAlignment.center }
					>
						Completa tus datos para pedir información sobre el Golf GTI Negro Carbón.
					</Text>
				</FormHeadline>
			),
			fields: (
				<FormWrapper>
					<InputsWrapper>
						<Nombre />
						<Apellido name="surname" required label="Primer apellido" />
						<Apellido name="secondSurname" label="Segundo apellido" required={false} />
					</InputsWrapper>
					<SubmitCTA
						tag="button"
						type="submit"
						emphasis="primary"
						onClick={(e) => {
							e.preventDefault();
							handleNextStep();
						}}
					>
						Siguiente
					</SubmitCTA>
				</FormWrapper>

			),
			screenIndex: index++,
			name: 'nombre',
			outputs: ['name', 'surname', 'secondSurname'],
			outputsText: ['name', 'surname', 'secondSurname'],
		},
		{
			title: (
				<Text textAlign={ TextAlignment.center } >
					<Text bold>¿En qué teléfono e email </Text>podemos localizarte?
				</Text>
			),
			fields: (
				<FormWrapper>
						<InputsWrapper>
							<Telefono required paddingTop="0px" />
							<Email required paddingTop="0px" />
						</InputsWrapper>
						<SubmitCTA
							tag="button"
							type="submit"
							emphasis="primary"
							onClick={(e) => {
								e.preventDefault();
								handleNextStep();
							}}
						>
							Siguiente
						</SubmitCTA>
				</FormWrapper>
			),
			screenIndex: index++,
			name: 'contacto',
			outputs: ['cellphone', 'email'],
			outputsText: ['cellphone', 'email'],
		},
		{
			title: (
				<Text textAlign={ TextAlignment.center } >
					<Text bold>¿Qué experto </Text>quieres que se encargue?*
				</Text>
			),
			fields: (
				<FormWrapper>
					<div className="form-map-wrapper">
						<MapaLeadsInPage
							title={<></>}
						/>
					</div>

					<div>
						<SubmitCTA
							tag="button"
							type="submit"
							emphasis="primary"
							onClick={(e) => {
								e.preventDefault();
								const activeElement = document.activeElement || document.querySelector('input');
								const enterEvent = new KeyboardEvent('keydown', {
									key: 'Enter',
									code: 'Enter',
									keyCode: 13,
									bubbles: true,
								});
								if (activeElement) {
									activeElement.dispatchEvent(enterEvent);
								}
							}}
						>
							Siguiente
						</SubmitCTA>
					</div>
				</FormWrapper>
			),
			screenIndex: index++,
			name: 'mapa',
			multiStep: true,
		},
		{
			fields: (
				<ConsentQuestionWrapper>
					<ConsentQuestion questionType="lssi" icon={iconRed} />
				</ConsentQuestionWrapper>
			),
			screenIndex: index++,
			name: 'lssi',
			outputs: ['lssi'],
		},
		{
			fields: (
				<ConsentQuestionWrapper className='form-consent-wrapper'>
					<ConsentQuestion questionType="tmk" icon={iconWhite} />
				</ConsentQuestionWrapper>
			),
			screenIndex: index++,
			name: 'tmk',
			outputs: ['tmk'],
		},
		{
			fields: <GTI50LeadConfirmacion />,
			screenIndex: index++,
			name: 'confirmacion',
			isLastStep: true,
			hidePreviousStep: true,
		}
	];

	const initialData: Partial<FormDataGroup> = {
		headers: {
			FK_SYSTEM: 'VW_DDB_FRM_LEM_REC_LEM',
			DPS_TOKEN: 'VW_DDB_FRM_LEM_REC_LEM',
			FORM_OBJECTIVE: 'Más Información',
		},
		flags: {
			PERSON_RGPD_ADAPTED: 'true',
			FLAG_IS_MYSTERY_LEAD: 'false',
			FLAG_RELACION_MARCA_SIN_IC: 'false',
			FLAG_SF_INTEGRATION: 'true',
			FLAG_ALLOWS_DATA_ENRICHMENT: 'false',
		},
		fields: {
			formularioFlag: 'masInformacion',
			formName: 'adhoc-2025-navidad_gti',
			formType: 'contact',
			pageCategory: 'Más Información',
		},
	};

	const getFormInfo = (): {
		firstStep: Steps;
		lastStep: Steps;
		stepsHistory: number[];
		numberOfScreens: number;
		newSteps?: Steps[];
	} => {
		return {
			firstStep: steps[0],
			lastStep: steps[steps.length - 1],
			stepsHistory: [0],
			numberOfScreens: steps.length,
			newSteps: null,
		};
	};

	const generateData = () => {
		const { formData, dealersInfo }: OneFormState = store.getState();
		const { fields, headers, flags } = formData;
		const { tc, today, url, device } = getParamsForm();
		const { selectedInstallation } = dealersInfo;

		console.log('fields', fields);

		return {
			...formatHeaders(headers),
			'headers[ORIGIN_DEVICE_TYPE]': device,
			'headers[ORIGIN_TRACKING_CODE]': tc,
			'headers[FORM_URL]': url,
			'headers[FORM_DATE_INSERTION]': today,
			'headers[FORM_NAME]': `vw-oneform-${fields.formName}`,
			'headers[FORM_VERSION]': `vw-oneform-${fields.formName}-${process.env.VERSION}`,
			
			...formatFlags(flags),

			'fields[DPS_BRAND]': 'Volkswagen',
			'fields[SF_LEAD_RECORDTYPE_NAME]': 'Sales Assistant',
			'fields[SF_LEAD_RECORDTYPE_ID]': '0121i000000D7NyAAK',
			'fields[SF_LEAD_SALES_INITIAL_ACTION]': 'Direct to Sales Assistant',

			'fields[SF_LEAD_INSTALLATION_ADDRESS]': selectedInstallation.ShippingStreet,
			'fields[SF_LEAD_INSTALLATION_CODE]': selectedInstallation.VGED_DealerCode__c,
			'fields[SF_LEAD_INSTALLATION_ID]': selectedInstallation.Id,
			'fields[SF_LEAD_INSTALLATION_NAME]': selectedInstallation.VGED_CommercialName__c,
			'fields[SF_LEAD_INSTALLATION_PROVINCE_CODE]': selectedInstallation.ShippingStateCode.toString().padStart(2, '0'),
			
			'fields[VEH_INTEREST_ID]': '30602',
			'fields[VEH_INTEREST_MODEL]': 'Golf',
			'fields[VEH_INTEREST_SALESGROUP]': 'Golf GTI',
			'fields[VEH_INTEREST_SALESGROUP_ID]': '35272',
			'fields[VEH_INTEREST_TRIM_LINE]': 'GTI',
			'fields[VEH_INTEREST_FUEL]': 'Combustion',
			'fields[VEH_INTEREST_NEW_OR_USED]': 'New Car',

			
			'fields[PERSON_NAME]': fields.name,
			'fields[PERSON_SURNAME_1]': fields.surname,
			'fields[PERSON_SURNAME_2]': fields.secondSurname,
			'fields[PERSON_EMAIL]': removeWhiteSpace(fields.email),
			'fields[PERSON_PHONE_MOBILE_FULL]': `${formatPrefix(fields.prefix)}${fields.cellphone}`,
			'fields[PERSON_PHONE_MOBILE]': fields.cellphone,
			'fields[PERSON_PHONE_PREFIX]': formatPrefix(fields.prefix),

			'fields[PERSON_RGPD_COM_COMERCIALES]': fields.lssi ? fields.lssi : 'NO INFORMADO',
			'fields[PERSON_RGPD_PERFILADO]': fields.tmk ? fields.tmk : 'NO INFORMADO',
			'flags[PERSON_RGPD_ADAPTED]': true
		};
	};

	const sendForm = async (): Promise<boolean> => {
		return new Promise<any>(async (resolve, reject) => {
			const data = generateData();
			const dataStringified = JSON.stringify(data);
			const dataParsed = JSON.parse(dataStringified);
			const formData = formDataBuilder(dataParsed);
			const response = await oneformBFFNdpsSend(formData);

			if (response?.data?.status?.code == 200) {
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });
				resolve(true);
			} else {
				dispatch({ type: 'UPDATE_FORM_ENDED', payload: true });
				resolve(false);
			}
		});
	};

	useEffect(() => {
		const { firstStep, lastStep, stepsHistory, numberOfScreens } = getFormInfo();

		const NuevoFormInfo: Partial<FormInfo> = {
			formStarted: true,
			sendFormCallback: sendForm,
			fullScreen: false,
			lastStep,
			numberOfScreens,
			notALayer: false,
			formTheme: 'inverted',
			formType: 'module',
			screenIndex: steps[0].screenIndex,
			step: firstStep,
			steps,
			stepsHistory,
			thankYouComponent: <NavidadGTI2025ThankYou />,
			hideLegal: true,
		};

		console.log("NuevoFormInfo", NuevoFormInfo);

		setLoading(false);
		initializeForm(NuevoFormInfo, initialData, true);
		trackingManager.trackFormLoad();
	}, []);

useEffect(() => {
	const params = new URLSearchParams(window.location.search);
	const targetId = params.get("scrollTo");
	if (!targetId) return;

	const tryScroll = () => {
		const el = document.getElementById(targetId);
		if (!el) return false;

		el.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});

		return true;
	};

	const initialTimeout = setTimeout(() => {
		if (tryScroll()) {
			clearInterval(intervalId);
			observer.disconnect();
			return;
		}
	}, 300);

	let attempts = 0;
	const maxAttempts = 10;

	const intervalId = setInterval(() => {
		attempts++;
		if (tryScroll() || attempts >= maxAttempts) {
			clearInterval(intervalId);
		}
	}, 100);

	const observer = new MutationObserver(() => {
		if (tryScroll()) {
			observer.disconnect();
			clearInterval(intervalId);
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: false,
	});

	return () => {
		clearTimeout(initialTimeout);
		clearInterval(intervalId);
		observer.disconnect();
	};
}, []);


	useLayoutEffect(() => {
		globalStyles();
		
		return () => {
			const style = document.getElementById('oneform-gti50-style');
			if (style) {
				style.remove();
			}
		}
	}), [];
	

	return errorInstallations ? (
		<>
			<Error />
		</>
	) : loading || loadingInstallations ? (
		<Loading />
	) : (
		<>
			<BlackSection data-oneform="navidad-gti-2025">
				<ThemeProvider theme={'inverted'}>
					<HeroSection />
					<GallerySection />
					<FormContainer>
						<FormStyled>
							<FormController steps={steps} screenType={'full-screen'} />
						</FormStyled>
						<div id='anchorEndForm'></div>
					</FormContainer>
					<VideoSection />
					<FooterSection />
				</ThemeProvider>
			</BlackSection>
		</>
	);
}
